import { useContext } from 'react'
import { SizeChartContext, type ISizeChartContext } from './SizeChartContext'

const useSizeChartContext = (): ISizeChartContext => {
  return useContext(SizeChartContext)
}

export default useSizeChartContext
